import {  useState, } from 'react';
import { X, UserCheck,  Plus,  Trash2,  Settings } from 'lucide-react';

// ─────────────────────────────────────────────
// Settings DRAWER COMPONENT
// ─────────────────────────────────────────────
export default function SettingsPanel({ open, onClose, employees, onAddEmployee, onRemoveEmployee }) {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleAdd = async () => {
    const employeeName = name.trim();
    if (!employeeName || loading) return;

    try {
      setLoading(true);
      await onAddEmployee(employeeName.toUpperCase());
      setName("");
    } catch (error) {
      console.error("Failed to add employee:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async (employee) => {
    if (loading) return;
    const confirmed = window.confirm(`Are you sure you want to remove ${employee.name}?`);
    if (!confirmed) return;

    try {
      setLoading(true);
      await onRemoveEmployee(employee._id);
    } catch (error) {
      console.error("Failed to remove employee:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-40 transition-opacity" onClick={onClose} />
      <div className="fixed right-0 top-0 h-full w-full max-w-md bg-white shadow-2xl z-[9999] flex flex-col animate-in slide-in-from-right duration-200">
        <div className="bg-gray-900 text-white p-5 flex items-center justify-between shrink-0">
          <div className="flex items-center gap-2">
            <Settings size={20} /> <h3 className="font-bold text-lg">Operations Settings</h3>
          </div>
          <button onClick={onClose} className="text-white/80 hover:text-white p-1 rounded hover:bg-white/10 transition-colors"><X size={20} /></button>
        </div>
        <div className="flex-1 overflow-y-auto p-5 space-y-6">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <UserCheck size={16} className="text-indigo-600" />
              <h4 className="font-bold text-sm text-gray-900">Fulfillment Employee Roster</h4>
            </div>
            <div className="flex gap-2 mb-4">
              <input type="text" placeholder="Employee name…" value={name} onChange={(e) => setName(e.target.value)}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-xs focus:ring-2 focus:ring-indigo-500 outline-none uppercase font-semibold bg-white"
                onKeyDown={(e) => e.key === 'Enter' && handleAdd()} />
              <button onClick={handleAdd} className="bg-indigo-600 text-white px-4 py-2 rounded-lg text-xs font-bold hover:bg-indigo-700 flex items-center gap-1 transition-colors">
                <Plus size={14} /> Add
              </button>
            </div>
            <div className="space-y-1.5">
              {employees.map((emp) => (
                <div
                  key={emp._id}
                  className="flex justify-between items-center bg-gray-50 hover:bg-gray-100 px-3 py-2 rounded-lg border border-gray-200 text-xs font-bold text-gray-800 transition-colors"
                >
                  <span className="flex items-center gap-2">
                    <div className="w-6 h-6 bg-indigo-100 text-indigo-700 rounded-full flex items-center justify-center text-[10px] font-bold">
                      {emp.name?.charAt(0)?.toUpperCase() || "?"}
                    </div>
                    {emp.name}
                  </span>

                  <button
                    onClick={() => handleRemove(emp)}
                    disabled={loading}
                    className="text-red-500 hover:text-red-700 hover:bg-red-50 p-1.5 rounded disabled:opacity-50 transition-all"
                  >
                    <Trash2 size={13} />
                  </button>
                </div>
              ))}

              {employees.length === 0 && (
                <div className="text-center text-xs text-gray-400 py-6">
                  No employees added yet.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}